export default "__VITE_ASSET__BAYBq_wR__"